import { generatePath } from "react-router-dom";

export const routes = {
  home: "/",
  map: "/map",
  scan: "/scan",
  appHandoff: "/app-handoff",
  account: "/account",
  auth: {
    register: "/auth/register",
    login: "/auth/login",
    requestPasswordReset: "/auth/request-password-reset",
    resetPassword: "/auth/reset-password",
    verifyEmail: "/auth/verify-email",
    verificationSent: "/auth/verification-sent",
  },
  admin: {
    index: "/admin-new",
    stations: "/admin-new/stations",
    exports: "/admin-new/exports",
    admins: "/admin-new/admins",
  },

  bookings: {
    index: "/bookings",
    my: "/bookings/my",
    detail: (bookingSlug: string) =>
      generatePath("/bookings/:bookingSlug", { bookingSlug }),
  },

  station: (stationId: string) =>
    generatePath("/stations/:stationId", { stationId }),

  booking: (bookingSlug: string) =>
    generatePath("/bookings/:bookingSlug", { bookingSlug }),

  camping: {
    index: (stationSlug: string) =>
      generatePath("/stations/:stationSlug", { stationSlug }),

    rent: {
      index: (stationSlug: string) =>
        generatePath("/stations/:stationSlug/rent", { stationSlug }),
      bikeSelection: (stationSlug: string) =>
        generatePath("/stations/:stationSlug/rent/bikes", { stationSlug }),
    },

    booking: {
      unlock: (stationSlug: string, bookingSlug: string) =>
        generatePath("/stations/:stationSlug/bookings/:bookingSlug", {
          stationSlug,
          bookingSlug,
        }),
      success: (stationSlug: string, bookingSlug: string) =>
        generatePath("/stations/:stationSlug/bookings/:bookingSlug/success", {
          stationSlug,
          bookingSlug,
        }),
    },
  },

  units: {
    index: (unitSlug: string) => generatePath("/units/:unitSlug", { unitSlug }),
    rent: {
      index: (unitSlug: string) =>
        generatePath("/units/:unitSlug/rent", { unitSlug }),
    },
  },
};
